import {
  createStyles,
  makeStyles,
  TableCell,
  Theme,
  withStyles,
} from '@material-ui/core';

export const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  button: {
    marginRight: 1,
    '&:last-child': {
      marginRight: 0,
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8,
    marginTop: 16,
    marginBottom: 16,
  },
  addButton: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    boxShadow: 'none',
    paddingLeft: 16,
    paddingRight: 16,
  },
  filterCard: {
    padding: 16,
    borderRadius: 12,
    marginBottom: 16,
    border: '1px solid rgba(0, 0, 0, 0.08)',
  },
  filterLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: 'rgba(0, 0, 0, 0.6)',
    marginBottom: 4,
    display: 'block',
  },
  formTitles: {
    fontWeight: 'bolder',
  },
  searchArea: {
    display: 'flex',
    alignItems: 'center',
  },
  searchButton: {
    marginLeft: '5px !important',
  },
  searchInput: {
    marginLeft: '5px !important',
  },
});

export const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.background.default,
    },
    body: {
      fontSize: 14,
    },
  }),
)(TableCell);
